module.exports = __webpack_public_path__ + "img/corazones.099291d9.svg";